<template>
  <component :is="currentComponent" :key="purchaseType"></component>
</template>
<script>
// Importamos los dos componentes que serán renderizados condicionalmente
import NewReservations from "../NewReservations.vue";
import NewReservationsVentrata from "../NewReservationsVentrata.vue";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["purchaseType"]),
    currentComponent() {
      if (this.purchaseType === "reservation") {
        return NewReservations;
      } else {
        return NewReservationsVentrata;
      }
    }
  }
};
</script>
